import { BubbleType, BubbleColor, ICore, Bubble, IBubbleHandler } from '../types';
import { IGameData } from 'js/bubbleCore/types';
import { putBubbleToGrid } from '../behavior/putBubbleToGrid';
import { getMatchingBubbles } from '../behavior/getMatchingBubbles';
import { popOutBubble } from '../behavior/popOutBubble';
import {
  IEvent,
  createUnsuccessfulMoveEvent,
} from 'js/bubbleCore/events';
import { BubbleGameBoard } from 'js/bubbleCore/BubbleGameBoard';

export interface IFireCore extends ICore {
  type: BubbleType.Fire;
  color: BubbleColor.NONE;
};

export type BubbleFire = Bubble<BubbleType.Fire>;

export const handler: IBubbleHandler<BubbleType.Fire> = {
  onShootedBubbleGridBubbleCollision,
  isMatching,
};

function onShootedBubbleGridBubbleCollision(
  board: BubbleGameBoard,
  bubble: BubbleFire,
  colliders: Bubble[],
): void {
  const data = board.getData();
  const grid = data.grid;
  const events = board.getEventsQueue();
  colliders.forEach((collider) => popOutBubble(board, collider));
}

function isMatching(bubble: BubbleFire, otherBubble: Bubble): boolean {
  return false;
}
